export default {
    index : 0,
    auth : {
        isLogin: true,
        isDone: false
    },
    cart:{
        woa:[],
        weibo:[],
        video:[],
        live:[],
        xhs:[],
        news:[],
    },
    cartLoading:false,
    cartTaxonomy:'woa',
    customerService:{},
    taxonomy : {
        // news: '软文推广',
        xhs: '小红书',
        video: '短视频',
        woa: '微信公众号',
        weibo: '新浪微博',
        live: '网红直播',

        //flow: '信息流',
    },
    ownActive : 'order',
    _profile : {
        name: '-',
        connect: {},
        company: {},
        agency:{},
        attribute: {
            taxonomies: []
        }
    },
    profile : {
        name: '-',
        connect: {},
        company: {},
        price_level: {},
        agency:{},
        attribute: {
            taxonomies: []
        }
    }
}



// WEBPACK FOOTER //
// ./src/vuex/state.js